<template>
  <div>
    <div class="coverShow" v-show="dialogVisible">
      <div class="container-gj" @click.stop>
        <div class="container-gd" @click.stop>
          <div class="header">
            <p>{{ headerTitle }}</p>
            <i
              class="fa-solid fa-circle-xmark"
              style="color: #8290a3; cursor: pointer"
              @click="handleClose"
            ></i>
          </div>
          <div class="content-container">
            <!-- 本题分数设置 -->
            <div
              v-if="
                dataObj.type === QuestionType.QA ||
                dataObj.type === QuestionType.MCQ ||
                dataObj.type === QuestionType.SBQ ||
                dataObj.type === QuestionType.MBQ
              "
              class="score-method"
              style="border-bottom: none"
            >
              <span class="section-title">得分方式</span>
              <div
                style="display: flex; align-items: center; cursor: pointer"
                @click="handleScoreWay"
              >
                <span class="setting-link">{{ getScoringMethod() }}</span>
                <img
                  src="https://ossfastmake.mustke.com/qrCode/tupian/1737516961703.svg"
                  style="height: 12px"
                />
              </div>
            </div>
            <div
              v-if="
                (dataObj.type === QuestionType.MCQ && scoringMethod === 1) ||
                dataObj.type === QuestionType.SBQ ||
                dataObj.type === QuestionType.MBQ
              "
              class="score-desc"
            >
              {{ getScoringDesc() }}
            </div>
            <div
              v-if="dataObj.type !== QuestionType.ClozeTest"
              class="score-section"
            >
              <span class="section-title">本题分数</span>
              <el-input-number
                v-model="questionScore"
                :precision="1"
                :step="0.5"
                :min="0"
                :max="1000"
              ></el-input-number>
            </div>
            <!-- 正确答案设置 -->
            <div class="answer-section">
              <div
                style="
                  display: flex;
                  align-items: center;
                  justify-content: flex-start;
                "
              >
                <span
                  v-if="
                    !(
                      dataObj.type === QuestionType.QA && scoringMethod !== 0
                    ) && dataObj.type !== QuestionType.ClozeTest
                  "
                  class="section-title"
                  style="margin-bottom: 12px"
                  >正确答案设置
                </span>
              </div>
              <!-- 选项列表 -->
              <div
                v-if="
                  dataObj.type === QuestionType.SCQ ||
                  dataObj.type === QuestionType.MCQ ||
                  dataObj.type === QuestionType.TFQ
                "
                v-for="(option, index) in options"
                :key="index"
                class="option-select-item"
                @click="selectCorrectAnswer(index)"
              >
                <span
                  class="option-label"
                  :style="{ color: option.isCorrect ? '#3A60FF' : '#4c4a56' }"
                >
                  {{ optionLabels[index] }}
                </span>
                <div
                  :class="[
                    option.isCorrect
                      ? 'option-content-select'
                      : 'option-content-unselect',
                  ]"
                >
                  <div class="option-text">{{ option.text }}</div>
                  <div class="correct-indicator" v-if="option.isCorrect">
                    <span class="correct-text">正确答案</span>
                  </div>
                </div>
                <div
                  class="option-show"
                  :class="{ active: option.isCorrect }"
                ></div>
              </div>
              <!-- 填空 -->
              <div
                v-if="
                  dataObj.type === QuestionType.SBQ ||
                  dataObj.type === QuestionType.MBQ
                "
                v-for="(option, index) in options"
                :key="index"
                class="option-input-item"
              >
                <div class="option-tit">{{ option.text }}</div>
                <el-input
                  v-model="option.correct_answer"
                  placeholder="请输入"
                  @focus="handleTextareaFocus(index)"
                  @blur="handleTextareaBlur()"
                />
              </div>
              <!-- 问答题 -->
              <div
                v-if="dataObj.type === QuestionType.QA && scoringMethod === 0"
              >
                <el-input
                  v-model="chooseAnswer"
                  placeholder="请输入"
                  @focus="handleQaFocus()"
                  @blur="handleQaBlur()"
                />
              </div>
              <!-- 完型填空-->
              <div
                style="
                  display: flex;
                  align-items: center;
                  justify-content: flex-start;
                  margin-top: 10px;
                "
              >
                <span class="section-title">总分{{ questionScore }}</span>
              </div>
              <div
                v-if="dataObj.type === QuestionType.ClozeTest"
                v-for="(item, idx) in options"
                :key="idx"
              >
                <div class="score-section" style="border-bottom: none">
                  <span class="section-title">题目分数设置</span>
                  <div style="display: flex; align-items: center">
                    <el-input-number
                      v-model="item.score"
                      :precision="1"
                      :step="0.5"
                      :min="0"
                      :max="1000"
                      @change="scoreChange($event, idx)"
                    ></el-input-number>
                    <span class="points-unit">分</span>
                  </div>
                </div>
                <span class="section-title" style="margin-bottom: 12px"
                  >正确答案设置</span
                >
                <div
                  v-for="(option, index) in item.title"
                  :key="index"
                  class="option-select-item"
                  @click="selectClozeCorrectAnswer(idx, index)"
                >
                  <span
                    class="option-label"
                    :style="{
                      color: option.isCorrect ? '#3A60FF' : '#4c4a56',
                    }"
                  >
                    {{ optionLabels[index] }}
                  </span>
                  <div
                    :class="[
                      option.isCorrect
                        ? 'option-content-select'
                        : 'option-content-unselect',
                    ]"
                  >
                    <div class="option-text">
                      {{ option.text || "选项" + (index + 1) }}
                    </div>
                    <div class="correct-indicator" v-if="option.isCorrect">
                      <span class="correct-text">正确答案</span>
                    </div>
                  </div>
                  <div
                    class="option-show"
                    :class="{ active: option.isCorrect }"
                  ></div>
                </div>
              </div>
            </div>
            <!-- 关键词设置 -->
            <div
              v-if="dataObj.type === QuestionType.QA && scoringMethod !== 0"
              class="explanation-section"
              style="margin-top: 10px; margin-bottom: 10px"
            >
              <span class="section-title">关键词设置</span>
              <div
                :style="{
                  border: keywordFocus
                    ? '1px solid #3A60FF'
                    : '1px solid #EDEDED',
                }"
                class="textarea-view"
              >
                <el-input
                  type="textarea"
                  v-model="keyword"
                  placeholder="关键词用分号隔开（例如：答案1；答案2；答案3），每个答案最多500字"
                  :autosize="{ minRows: 1 }"
                  @focus="handleKeywordFocus()"
                  @blur="handleKeywordBlur()"
                />
              </div>
            </div>
            <!-- 答案解析 -->
            <div
              class="explanation-section"
              style="margin-top: 10px; margin-bottom: 10px"
            >
              <div
                style="
                  display: flex;
                  align-items: center;
                  justify-content: flex-start;
                "
              >
                <span class="section-title">答案解析（非必填）</span>
              </div>
              <el-input
                class="textarea"
                v-model="explanation"
                :autosize="{ minRows: 1 }"
                placeholder="请输入"
                style="margin-top: 10px"
                @focus="handleExplanationFocus()"
                @blur="handleExplanationBlur()"
              />
            </div>
          </div>
          <div class="dialog-footer">
            <el-button @click="cancelClick" style="width: 120px">
              {{ cancel }}
            </el-button>
            <el-button
              type="primary"
              @click="confirmClick"
              style="width: 120px"
            >
              {{ confirm }}
            </el-button>
          </div>
        </div>
      </div>
    </div>
    <!-- <el-dialog
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      width="700px"
      :close-on-click-modal="false"
      custom-class="vertical-dialog"
    >
    </el-dialog> -->

    <!-- 得分方式选择 -->
    <div class="coverShow score-z-index" v-show="showActionSheet">
      <div class="container-gj score-z-index" @click.stop>
        <div class="container-gd score-z-index" @click.stop>
          <div class="header">
            <p>得分方式</p>
            <i
              class="fa-solid fa-circle-xmark"
              style="color: #8290a3; cursor: pointer"
              @click="showActionSheet = false"
            ></i>
          </div>
          <div class="action-list">
            <div
              v-for="(action, index) in actionOptions"
              :key="index"
              class="action-item"
              @click="selectActionOption(action)"
            >
              <div class="action-content">
                <div class="action-name">{{ action.name }}</div>
                <div v-if="action.desc" class="action-desc">
                  {{ action.desc }}
                </div>
              </div>
              <i
                v-if="action.value === scoringMethod"
                class="el-icon-check action-check"
              ></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <el-dialog
      :visible.sync="showActionSheet"
      title="得分方式"
      width="500px"
      :close-on-click-modal="true"
    >
      
    </el-dialog> -->

    <!-- 分数提示 -->
    <el-dialog
      :visible.sync="showScore"
      width="300px"
      :show-close="false"
      center
    >
      <div class="score-tip">
        <div class="tip-text">当前分数为0，可以设置分数</div>
        <el-button type="primary" @click="showScore = false" class="tip-btn">
          我知道了
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "ExamAnswerSetting",
  components: {
    // Stepper,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    dataObj: {
      type: Object,
      default: () => ({}),
    },
    cancel: {
      type: String,
      default: "取消",
    },
    confirm: {
      type: String,
      default: "确定",
    },
  },
  data() {
    return {
      QuestionType: {
        SCQ: 1, // 单选
        MCQ: 2, // 多选
        SBQ: 3, // 填空
        MBQ: 4, // 多项填空
        DLQ: 5, // 下拉
        NPS: 6, // NPS
        VOTE: 7, // 投票
        SORT: 8, // 排序
        REMARK: 9, // 备注
        SCORE: 10, // 分数评定
        QA: 11, // 问答
        WRQ: 12, // 权重评分
        SRQ: 13, // 评星
        NAME: 14, // 姓名
        GENDER: 15, // 性别
        AGE: 16, // 年龄
        TEL: 17, // 电话号
        EMAIL: 18, // 邮箱
        DATE: 19, // 日期
        TIME: 20, // 时间
        ADDR: 21, // 地址
        TFQ: 22, // 判断题
        IMAGE: 23, // 图片
        MaxDiff: 24, // MaxDiff题
        UploadFile: 25, // 上传文件
        DownloadFile: 26, // 下载附件
        CASCADER: 27, // 联极题
        ClozeTest: 28, // 完形填空
        BDQ: 29, // 出生日期
        IDQ: 30, // 身份证号
        ELQ: 31, // 学历
        WX: 32, // 微信号
        TITLE: 33, // 标题
        PageBreak: 34, // 分页线
        MatrixSCQ: 35, // 矩阵单选
        MatrixMCQ: 36, // 矩阵多选
        ImageSCQ: 37, // 图片单选
        ImageMCQ: 38, // 图片多选
        ImageOrVideo: 39, // 图片/视频
        Signature: 40, // 签名
        Industry: 41, // 行业
        Occupation: 42, // 职业
        EvaluationSCQ: 43, // 测评单选
        EvaluationMCQ: 44, // 测评多选
        EvaluationWRQ: 45, // 测评权重评分
        EvaluationNPS: 46, // 测评NPS
        EvaluationScore: 47, // 测评分数评定
        TextDescription: 48, // 文本描述
      },
      dialogVisible: false,
      questionPoints: 1,
      options: [],
      optionLabels: [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
      ],
      explanation: "",
      questionScore: 0,
      isFocusIndex: -1,
      explanationFocus: false,
      qaFocus: false,
      keywordFocus: false,
      headerTitle: "单选答案与分值",
      chooseAnswer: "",
      scoringMethod: 0,
      actions1: [
        {
          name: "回答与答案完全相同",
          value: 0,
        },
        {
          name: "答对几个关键词得几分",
          desc: "总分/关键词数量*用户答对项数量",
          value: 1,
        },
        {
          name: "回答包含全部关键词",
          value: 2,
        },
        {
          name: "答对任意关键词即得分",
          value: 3,
        },
      ],
      actions2: [
        {
          name: "所有填空选项全部答对",
          desc: "回答与答案完全相同才得分",
          value: 0,
        },
        {
          name: "答对几空得几分",
          desc: "总分/正确项数量*用户答对项数量",
          value: 1,
        },
      ],
      actions3: [
        {
          name: "全部答对",
          value: 0,
        },
        {
          name: "少选得部分分；选错得0分",
          desc: "总分/正确项数量*用户答对项数量",
          value: 1,
        },
      ],
      actions4: [
        {
          name: "所有填空选项全部答对",
          value: 0,
        },
        {
          name: "答对几空得几分",
          value: 1,
        },
      ],
      actionOptions: [],
      showActionSheet: false,
      keyword: "",
      showScore: false,
    };
  },
  watch: {
    show: {
      handler(newVal) {
        this.dialogVisible = newVal;
      },
      immediate: true,
    },
    dataObj: {
      handler(newVal) {
        if (!newVal || Object.keys(newVal).length === 0) return;

        // console.log(
        //   "哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈",
        //   newVal,
        //   newVal.type === this.QuestionType.SBQ,
        // );
        console.log("frhfr393h12ir1hri21rh21ior1", newVal);

        console.log("newVal.type", newVal.type);
        this.questionScore = newVal.questionScore;

        if (newVal.type === this.QuestionType.SCQ) {
          this.headerTitle = "单选答案与分值";
          this.explanation = newVal.explanation;
          this.options = JSON.parse(newVal.chooseList).list;
        } else if (newVal.type === this.QuestionType.MCQ) {
          this.headerTitle = "多选答案与分值";
          this.options = JSON.parse(newVal.chooseList).list;
          this.scoringMethod = newVal.scoringMethod ? newVal.scoringMethod : 0;
          this.explanation = newVal.explanation;
        } else if (newVal.type === this.QuestionType.TFQ) {
          this.headerTitle = "判断答案与分值";
          this.options = JSON.parse(newVal.chooseList).list;
          this.explanation = newVal.explanation;
        } else if (newVal.type === this.QuestionType.SBQ) {
          console.log("g21e2f2fr2f1rt21frty21frty21rf1232112", newVal.analysis);
          this.headerTitle = "填空答案与分值";
          this.scoringMethod = newVal.scoringMethod ? newVal.scoringMethod : 0;
          this.actionOptions = this.actions1;
          this.explanation = newVal.explanation;
          console.log("dqwdwqdqwfqwfqwfqw", newVal.chooseAnswer);
          this.options = [];
          if (newVal.chooseAnswer === "") {
            for (
              let i = 0;
              i < newVal.caseProblem.split("____").length - 1;
              i++
            ) {
              this.options.push({
                text: "填空" + (i + 1),
                correct_answer: "",
              });
            }
          } else {
            const answerArr = newVal.chooseAnswer.split(";");
            for (
              let i = 0;
              i < newVal.caseProblem.split("____").length - 1;
              i++
            ) {
              this.options.push({
                text: "填空" + (i + 1),
                correct_answer: answerArr[i],
              });
            }
          }
        } else if (newVal.type === this.QuestionType.MBQ) {
          this.headerTitle = "多项填空答案与分值";
          this.options = JSON.parse(newVal.chooseList).list;
          this.scoringMethod = newVal.scoringMethod ? newVal.scoringMethod : 0;
          this.actionOptions = this.actions1;
          this.explanation = newVal.explanation;
        } else if (newVal.type === this.QuestionType.QA) {
          this.headerTitle = "问答答案与分值";
          this.chooseAnswer = newVal.chooseAnswer;
          this.scoringMethod = newVal.scoringMethod ? newVal.scoringMethod : 0;
          this.actionOptions = this.actions1;
          this.keyword = newVal.keyword;
          this.explanation = newVal.analysis;
        } else if (newVal.type === this.QuestionType.ClozeTest) {
          console.log(
            "g21e2f2fr2f1rt21frty21frty21rf1232112",
            JSON.parse(newVal.chooseList).list,
          );
          this.options = JSON.parse(newVal.chooseList).list;
          this.headerTitle = "完型填空答案与分值";
          this.explanation = newVal.explanation;
        } else {
          this.headerTitle = "单选答案与分值";
          this.explanation = newVal.explanation;
        }

        if (this.dataObj.type === this.QuestionType.QA) {
          this.actionOptions = this.actions1;
        } else if (this.dataObj.type === this.QuestionType.MCQ) {
          this.actionOptions = this.actions3;
        } else {
          this.actionOptions = this.actions2;
        }
        console.log("43t9j3t4389yt4378ty4378ty4378ty7348t34", this.explanation);
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    handleClose() {
      this.$emit("close");
    },
    cancelClick() {
      this.$emit("close");
    },
    confirmClick() {
      if (
        this.dataObj.type === this.QuestionType.SCQ ||
        this.dataObj.type === this.QuestionType.MCQ ||
        this.dataObj.type === this.QuestionType.TFQ
      ) {
        const isCorrect = this.options.some((item) => item.isCorrect);
        if (!isCorrect) {
          this.$message.error("请设置正确答案");
          return;
        }
      }
      if (
        this.dataObj.type === this.QuestionType.SBQ ||
        this.dataObj.type === this.QuestionType.MBQ
      ) {
        const isCorrect = this.options.some(
          (item) => item.correct_answer.trim() === "",
        );
        if (isCorrect) {
          this.$message.error("请填写正确答案");
          return;
        }
      }
      if (this.dataObj.type === this.QuestionType.QA) {
        if (this.chooseAnswer === "" && this.scoringMethod === 0) {
          this.$message.error("请填写正确答案");
          return;
        }
        if (
          (this.scoringMethod === 1 || this.scoringMethod === 2) &&
          this.keyword === ""
        ) {
          this.$message.error("请填写关键词");
          return;
        }
      }
      if (this.questionScore === 0) {
        this.showScore = true;
      }
      console.log("state11111111", this.options);
      this.$emit(
        "confirm",
        JSON.stringify({
          questionScore: this.questionScore,
          chooseList: JSON.stringify({
            list: this.options,
          }),
          explanation: this.explanation,
          chooseAnswer: this.chooseAnswer,
          scoringMethod: this.scoringMethod,
          keyword: this.keyword,
        }),
      );
    },
    selectCorrectAnswer(index) {
      if (
        this.dataObj.type === this.QuestionType.SCQ ||
        this.dataObj.type === this.QuestionType.TFQ
      ) {
        this.options.forEach((option, i) => {
          option.isCorrect = i === index;
        });
      } else {
        this.options[index].isCorrect = !this.options[index].isCorrect;
      }
      this.$forceUpdate();
    },
    selectClozeCorrectAnswer(idx, index) {
      this.options[idx].title.forEach((option, i) => {
        option.isCorrect = i === index;
      });
      this.$forceUpdate();
      console.log("dwqdqwfqwfqwfqwfqwfqw", this.options);
    },
    handleScoreWay() {
      this.showActionSheet = true;
    },
    selectActionOption(action) {
      this.scoringMethod = action.value;
      this.showActionSheet = false;
    },
    handleTextareaFocus(index) {
      this.isFocusIndex = index;
      this.explanationFocus = false;
    },
    handleTextareaBlur() {
      this.isFocusIndex = -1;
    },
    handleExplanationFocus() {
      this.explanationFocus = true;
      this.isFocusIndex = -1;
    },
    handleExplanationBlur() {
      this.explanationFocus = false;
    },
    handleQaFocus() {
      this.qaFocus = true;
      this.isFocusIndex = -1;
    },
    handleQaBlur() {
      this.qaFocus = false;
    },
    handleKeywordFocus() {
      this.keywordFocus = true;
      this.isFocusIndex = -1;
    },
    handleKeywordBlur() {
      this.keywordFocus = false;
    },
    getScoringMethod() {
      const action = this.actionOptions.find(
        (action) => action.value === this.scoringMethod,
      );
      return action ? action.name : "";
    },
    getScoringDesc() {
      const action = this.actionOptions.find(
        (action) => action.value === this.scoringMethod,
      );
      return action ? action.desc : "";
    },
    scoreChange(e, idx) {
      console.log("e", e);
      this.options[idx].score = e;
      this.questionScore = this.options.reduce(
        (total, item) => total + (item.score || 0),
        0,
      );
    },
    handleStepperUpdate(e) {
      this.questionScore = e;
    },
  },
};
</script>

<style lang="scss" scoped>
.coverShow {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.container-gj {
  position: fixed;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.65);
  z-index: 99;
  transform: translate(-50%, -50%);
}

.container-gd {
  /* padding: 17px 28px; */
  position: fixed;
  top: 50%;
  left: 50%;
  width: 700px;
  /* height: 600px; */
  background: #ffffff;
  z-index: 99;
  transform: translate(-50%, -50%);
  // overflow: hidden;
  border-radius: 10px;
  max-height: 500px;
  overflow-y: auto;
  padding: 20px;
}

.container-gd::-webkit-scrollbar {
  // display: none;
}

.header {
  width: 100%;
  height: 55px;
  border-bottom: 1px solid #e7e7e7;
  position: relative;

  p {
    font-size: 18px;
    font-weight: 500;
    color: #333333;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  i {
    font-size: 20px;
    font-weight: 500;
    color: #333333;
    position: absolute;
    top: 50%;
    right: 10px;
    transform: translateY(-50%);
  }
}

.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .header-title {
    font-size: 18px;
    font-weight: 600;
    color: #4c4a56;
  }
}

.content-container {
  max-height: 500px;
  // overflow-y: auto;
  padding: 20px 0;
  box-sizing: initial;
}

.dialog-footer {
  display: flex;
  justify-content: center;
  gap: 10px;
}

.score-method {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #e7e7e7;
  width: 100%;
}

.score-section {
  height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e7e7e7;
}

.section-title {
  display: inline-block;
  font-size: 16px;
  color: #4c4a56;
  font-weight: 600;
  text-align: left;
  // width: 100%;
}

.points-unit {
  margin-left: 9px;
  font-size: 15px;
  color: #555555;
}

.answer-section {
  margin-top: 12px;
}

.option-select-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  cursor: pointer;
}

.option-label {
  font-size: 15px;
  margin-right: 10px;
  font-weight: 600;
}

.option-content-select {
  flex: 1;
  border: 1px solid rgba(58, 96, 255, 0.5);
  border-radius: 4px;
  padding: 12px 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: rgba(58, 96, 255, 0.1);
}

.option-content-unselect {
  flex: 1;
  border: 1px solid #dcdde0;
  border-radius: 4px;
  padding: 12px 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f8f8f8;
}

.option-text {
  font-size: 14px;
  color: #4c4a56;
  max-width: 380px;
  word-break: break-all;
}

.option-show {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid #e5e6e8;
  margin-left: 10px;
  flex-shrink: 0;
}

.option-show.active {
  border-color: #3a60ff;
  background: #3a60ff;
  position: relative;
}

.option-show.active::before {
  display: block;
  content: "";
  width: 6px;
  height: 12px;
  border-right: 2px solid #fff;
  border-bottom: 2px solid #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(45deg);
  margin-top: -2px;
}

.option-tit {
  font-size: 14px;
  color: #4c4a56;
  width: 100%;
  word-break: break-all;
  margin-bottom: 8px;
  width: 100%;
  text-align: left;
}

.correct-indicator {
  display: flex;
  align-items: center;
}

.correct-text {
  color: #00c755;
  font-size: 14px;
  margin-right: 5px;
}

.explanation-section {
  box-sizing: border-box;
}

.option-input-item {
  margin-bottom: 15px;
}

.textarea-view {
  width: 100%;
  background: #f7f7f7;
  border: 1px solid #ededed;
  border-radius: 4px;
  padding: 8px;
  box-sizing: border-box;
  margin-top: 8px;

  ::v-deep .el-textarea__inner {
    background: transparent;
    border: none;
    padding: 0;
    color: #4c4a56;
    min-height: 20px;
  }
}

.setting-link {
  color: #3a60ff;
  font-size: 14px;
  margin-right: 4px;
}

.score-desc {
  width: 100%;
  font-size: 13px;
  font-weight: 400;
  text-align: right;
  color: #949eaf;
}

// Action sheet styles
.action-list {
  .action-item {
    padding: 15px;
    border-bottom: 1px solid #f0f0f0;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &:hover {
      background-color: #f5f7fa;
    }

    &:last-child {
      border-bottom: none;
    }

    .action-content {
      flex: 1;

      .action-name {
        font-size: 15px;
        color: #2b2f36;
        margin-bottom: 4px;
      }

      .action-desc {
        font-size: 13px;
        color: #949eaf;
      }
    }

    .action-check {
      color: #3a60ff;
      font-size: 18px;
    }
  }
}

// Score tip styles
.score-tip {
  text-align: center;
  padding: 20px;

  .tip-text {
    color: #2b2f36;
    font-size: 15px;
    font-weight: 500;
    margin-bottom: 20px;
  }

  .tip-btn {
    width: 120px;
    margin: 0 auto;
  }
}

.score-z-index {
  z-index: 105;
}
</style>
<style>
/* 提高 el-dialog 的 z-index，确保不被其他元素遮挡 */

.vertical-dialog .el-dialog__body {
  padding: 0 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/ExamAnswerSetting/ExamAnswerSetting.vue